import { makeStyles } from '@mui/styles';
import * as colors from 'apollo-react/colors';
import Tab from 'apollo-react/components/Tab';
import * as icons from 'apollo-react-icons';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';
import ControlChangesIcon from '../components/ControlChangesIcon';
import { FCM_BORDER_STYLES } from '../constants/runtime.constants';

const useStyles = makeStyles({
  changesModeWrapper: {
    marginRight: 32,
    border: FCM_BORDER_STYLES.CONDITIONAL,
    '& button': {
      margin: 0,
      paddingLeft: 8,
      paddingRight: 12,
    },
  },
  ssSingleTabButton: {
    height: '100%',
    paddingBottom: 10,
  },
});

const SSSingleTab = ({
  label,
  isViewOnly,
  onChange,
  tabIndex,
  isEditor,
  selected,
  id,
  instanceId,
  isControlAddedFCM,
  isControlChangedFCM,
  isControlHiddenFCM,
  displayIcon,
  displayIconColor,
}) => {
  const classes = useStyles({ isControlAddedFCM });
  const translateString = useTranslation();

  const Icon = displayIcon && icons[displayIcon];

  const iconProps = {
    fontSize: '16',
    htmlColor: colors[displayIconColor ?? 'neutral7'],
  };

  const tab = (
    <Tab
      className={isEditor ? classes.ssSingleTabButton : null}
      sx={{
        '& .MuiTab-iconWrapper': {
          color: colors[displayIconColor ?? 'neutral7'],
        },
      }}
      label={label || translateString('Detail')}
      disabled={(isViewOnly && !isEditor) || isControlHiddenFCM}
      onChange={onChange}
      value={tabIndex}
      aria-selected={selected}
      ui-ta={getUITA('FormCtrl', 'SSSingleTab', label)}
      data-tab-selected={selected}
      selected={selected}
      id={instanceId}
      data-ss-id={id}
      icon={Icon && <Icon {...iconProps} />}
    />
  );

  if (isControlAddedFCM || isControlChangedFCM) {
    return (
      <div className={classes.changesModeWrapper} data-ss-id={id}>
        {tab}
        {isControlChangedFCM && <ControlChangesIcon id={id} />}
      </div>
    );
  }

  return tab;
};

export default SSSingleTab;
